<template>
  <div>
    <v-carousel>
      <v-carousel-item
        :src="'/img/acdeehllopr/chip.jpg'"
        reverse-transition="fade-transition"
        transition="fade-transition"
      ></v-carousel-item>
      <v-carousel-item
        :src="'/img/acdeehllopr/cloud.jpg'"
        reverse-transition="fade-transition"
        transition="fade-transition"
      ></v-carousel-item>
      <v-carousel-item
        :src="'/img/acdeehllopr/island.jpg'"
        reverse-transition="fade-transition"
        transition="fade-transition"
      ></v-carousel-item>
      <v-carousel-item
        :src="'/img/acdeehllopr/water.jpg'"
        reverse-transition="fade-transition"
        transition="fade-transition"
      ></v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
export default {
  props: [],
  data() {
    return {};
  },
  watch: {},
  methods: {},
  mounted() {},
  created() {},
  beforeCreate() {},
  computed: {},
};
</script>

<style>
</style>
